module.exports = __webpack_public_path__ + "static/img/certify01.ec2595c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/swiper/images/certify01.png
// module id = ua5+
// module chunks = 1